import { SHOW_CUSTOMIZED_MESSAGE, HIDE_CUSTOMIZED_MESSAGE, UPDATE_CUSTOMIZED_MESSAGE_DATA } from '../Actions/CustomizedMessage.action';
const defaultState = {
  showMessage: false,
  message: '',
  icon: '',
  color: '',
  textColor: ''
};

export const CustomizedMessage = (state = defaultState, action) => {
  switch (action.type) {
    case SHOW_CUSTOMIZED_MESSAGE:
      return {
        ...state,
        ...action.payload,
        showMessage: true,
      };
    case HIDE_CUSTOMIZED_MESSAGE:
      return {
        ...state,
        ...action.payload,
        showMessage: false,
      };
    case UPDATE_CUSTOMIZED_MESSAGE_DATA:
      return {
        ...state,
        message: action.payload.message,
        icon: action.payload.icon,
        color: action.payload.color,
        textColor: action.payload.textColor,
        showMessage: true,
      };
    default:
      return state;
  }
};
